import React, { ComponentProps } from 'react';

import Tooltip from '../Tooltip';

const defaultRenderBody = (props: ComponentProps<typeof Tooltip.Body>) => (
  <Tooltip.Body {...props} padding={16} />
);
const defaultRenderTarget = (props: ComponentProps<typeof Tooltip.Target>) => (
  <Tooltip.Target {...props} shouldWrapChildren={false} />
);

export type FlyoutProps = React.ComponentProps<typeof Tooltip>;

const Flyout = ({
  trigger = Tooltip.TRIGGER_EVENTS.CLICK,
  variant = Tooltip.VARIANTS.LIGHT,
  renderTarget = defaultRenderTarget,
  delayShow = 100,
  delayHide = 0,
  ...props
}: FlyoutProps) => {
  return (
    <Tooltip
      trigger={trigger}
      variant={variant}
      renderBody={defaultRenderBody}
      delayShow={delayShow}
      delayHide={delayHide}
      renderTarget={renderTarget}
      {...props}
    />
  );
};

Flyout.displayName = 'Flyout';

Flyout.propTypes = Tooltip.propTypes;

export default Object.assign(Flyout, {
  Arrow: Tooltip.Arrow,
  Target: Tooltip.Target,
  Body: Tooltip.Body,
  VARIANTS: Tooltip.VARIANTS,
  PLACEMENTS: Tooltip.PLACEMENTS,
  TRIGGER_EVENTS: Tooltip.TRIGGER_EVENTS,
  TRIGGER_TARGETS: Tooltip.TRIGGER_TARGETS,
});
